var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkeleton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 248 274",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#43464c"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "#43464c; #EEEEEE; #43464c",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#43464c"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "#43464c; #FFFFFF; #43464c",
    dur: "2s",
    repeatCount: "indefinite"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    fill: "url('#a')"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 60,
    rx: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 76,
    r: 10
  }), /*#__PURE__*/React.createElement("rect", {
    y: 258,
    width: 48,
    height: 16,
    rx: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 266,
    r: 8
  }), /*#__PURE__*/React.createElement("rect", {
    y: 234,
    width: 90,
    height: 16,
    rx: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 242,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 240h-96a2 2 0 0 0 0 4h96a2 2 0 0 0 0-4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 210,
    width: 58,
    height: 16,
    rx: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 218,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 216h-96a2 2 0 0 0 0 4h96a2 2 0 0 0 0-4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 172,
    width: 59,
    height: 24,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.5,
    y: 172,
    width: 59,
    height: 24,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.5,
    y: 172,
    width: 59,
    height: 24,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    y: 92,
    width: 248,
    height: 60,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 68,
    width: 23,
    height: 16,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 68,
    width: 23,
    height: 16,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 68,
    width: 23,
    height: 16,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 68,
    width: 23,
    height: 16,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 265h-96a2 2 0 0 0 0 4h96a2 2 0 0 0 0-4Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkeleton);
export default __webpack_public_path__ + "static/media/skeleton.70a1d79041804ad46cdabae99eb5dc98.svg";
export { ForwardRef as ReactComponent };